// 專題 - youtube 區塊
const ProjectYoutube = ({ youtubeList }) => {
  return (
    <section className="relative py-[56px] w-full max-w-[680px] mx-auto usm:py-[45px] uxs:!py-[35px]">
      {youtubeList?.map((youtube, i) => (
        <div
          key={youtube?.youtubeLink + i + "youtube"}
          className={`w-full space-y-[35px] relative z-[1] ${
            i < youtubeList?.length - 1 ? "mb-[50px]" : ""
          }`}
        >
          <div className="relative w-full aspect-[16/9]">
            {/* 影片 iframe */}
            <iframe
              className="w-full h-full object-cover"
              src={youtube?.youtubeLink}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>

          <div
            className="news-content text-bd2n text-black"
            dangerouslySetInnerHTML={{ __html: youtube?.youtubeDesc }}
          />
        </div>
      ))}

      {/* 背景色 */}
      <div className="absolute !w-screen h-full z-[0] top-0 left-[50%] translate-x-[-50%] bg-black1" />
    </section>
  );
};

export default ProjectYoutube;
